import React from 'react'
import { Typography, Stack } from '@mui/material';
import { TextField } from '@mui/material';
import { Button, Grid, Link } from '@mui/material';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import colors from '../../colors'
import { useSelector, useDispatch } from 'react-redux';
import { selectRegistrationState, decrementCurrentRegistrationStep, setAddress, setBirthdate, setCity, setFullName, setGender, setBusinessName } from '../../../features/registration/registrationSlice'
import { setToken } from '../../../features/global/globalDataSlice'
import FormHelperText from '@mui/material/FormHelperText';
import moment from 'moment';
import { useFormik } from 'formik'
import * as yup from 'yup'
import Checkbox, { checkboxClasses } from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import { LocalizationProvider } from '@mui/lab';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import { sendGeneralRequest } from '../../../features/generalRequest'
import { selectTermsAndConditionsState } from '../../../features/termsAndConditions/termsAndConditionsSlice'
import { makeStyles } from '@mui/styles';
import { texts } from '../../general/texts';

export const BusinessAccountFifthRegistrationStep = () => {

    const registrationSliceState = useSelector(selectRegistrationState)
    const termsAndConditionsSliceState = useSelector(selectTermsAndConditionsState)
    const dispatch = useDispatch()


    const validationSchema = yup.object({

        city: yup
            .string(texts["message-invalid-city"])
            .required(texts["message-invalid-city"]),
        address: yup
            .string(texts["message-invalid-address"])
            .required(texts["message-invalid-address"]),
        fullName: yup
            .string(texts["message-invalid-full-name"])
            .matches(/[a-zA-z]+\s[a-zA-z]+\s[a-zA-z]+/, {
                message: "Formati i sakte eshte: Emër Atësi Mbiemër",
            })
            .required(texts["message-invalid-full-name"]),
        businessName: yup
            .string(texts["message-invalid-business-name"])
            .required(texts["message-invalid-business-name"]),
        birthDate: yup
            .string(texts["message-invalid-birthdate"])
            // .matches(/^[0-9]{2}[\/][0-9]{2}[\/][0-9]{4}$/,{
            //     message:'Datelindja duhet te jete ne formatin DD/MM/YYYY'
            // })
            .required(texts["message-invalid-birthdate"])
            .nullable(),
        gender: yup
            .string(texts["message-invalid-gender"])
            .required(texts["message-invalid-gender"]),
        idTC: yup
            .bool()
            .oneOf([true], texts["message-invalid-terms-and-conditions"])
    });

    const formik = useFormik({
        initialValues: {
            token: registrationSliceState.token,
            fullName: '',
            city: '',
            address: '',
            birthDate: '',
            gender: '',
            businessName: '',
            idTC: false,
            ext: registrationSliceState.idPictureExtension,
            base64Content: registrationSliceState.idPictureBase64,
            idNumber: registrationSliceState.idNumber,
            expiryDate: moment(registrationSliceState.idExpiryDate).format('DD/MM/yyyy'),
            accountType: registrationSliceState.accountType,
            documentNumber: '',
            isFacephi: false,
            income: '',
            isPep: false,
            nationality: '',
            secondaryAddress: '',
            taxNumber: ''
            //identificationDocumentType:"N/A"
        },
        validationSchema: validationSchema,
        onSubmit: values => {
            var splitFullName = values.fullName.split(/(\s+)/);
            dispatch(setToken(registrationSliceState.token))
            dispatch(sendGeneralRequest({ request: { _request: { ...values, idTC: termsAndConditionsSliceState.idTC, idPrivacyPolicy: termsAndConditionsSliceState.idPrivacyPolicy, birthDate: moment(values.birthDate).format('DD/MM/yyyy'), name: splitFullName[0].charAt(0).toUpperCase() + splitFullName[0].slice(1), fathersName: splitFullName[2].charAt(0).toUpperCase() + splitFullName[2].slice(1), surname: splitFullName[4].charAt(0).toUpperCase() + splitFullName[4].slice(1) } }, baseUrlKey: 'auth', endpoint: 'UpdateUserDataNew' }))


        }
    })

    const onBackButtonClick = () => {
        dispatch(setFullName(formik.values.fullName))
        dispatch(setAddress(formik.values.address))
        dispatch(setCity(formik.values.city))
        dispatch(setBirthdate(formik.values.birthDate))
        dispatch(setGender(formik.values.gender))
        dispatch(setBusinessName(formik.values.businessName))
        dispatch(decrementCurrentRegistrationStep())
    }

    React.useEffect(() => {
        dispatch(sendGeneralRequest({ request: { _request: { TypeOfAccount: registrationSliceState.accountType } }, baseUrlKey: 'auth', endpoint: 'GetTermsAndConditions' }))
    }, [])

    React.useEffect(() => {
        formik.setFieldValue('fullName', registrationSliceState.fullName)
        formik.setFieldValue('address', registrationSliceState.address)
        formik.setFieldValue('city', registrationSliceState.city)
        formik.setFieldValue('birthDate', registrationSliceState.birthDate)
        formik.setFieldValue('gender', registrationSliceState.gender)
        formik.setFieldValue('businessName', registrationSliceState.businessName)
    }, [registrationSliceState.fullName, registrationSliceState.address, registrationSliceState.city, registrationSliceState.birthDate, registrationSliceState.gender])


    const useStyles = makeStyles({
        mainGrid: {
            width: '60%',
            '@media (min-width: 899px)': { marginLeft: '15%' },
            '@media (max-width: 1440px)': { width: '70%' },
            '@media (max-width: 1024px)': { width: '85%' },
            '@media (max-width: 768px)': { width: '80%' },
            '@media (max-width: 425px)': { width: '90%' }
        },
        fieldTitle: {
            color: colors.orange,
            fontSize: '1.2rem',
            fontFamily: 'GerberaMedium'
        },
        textField: {
            width: '15vw',
            '@media (max-width: 899px)': { width: '70vw' }
        },
        button: {
            background: colors.gradientOrange,
            color: colors.white,
            width: '12%',
            fontFamily: 'GerberaBold',
            textTransform: 'none',
            fontSize: '1rem',
            '@media (max-width: 899px)': { width: '40%' }
        },
        link: {
            fontFamily: 'GerberaLight',
            color: colors.orange,
            textDecorationColor: colors.orange,
            "&:hover": { textDecorationColor: '#FF8403', color: '#FF8403' }
        }
    })

    const classes = useStyles()

    return (
        <form onSubmit={formik.handleSubmit}>
            <Grid container justifyContent='center' width={'100%'}>
                <Grid container item className={classes.mainGrid}>
                    <Grid container item md={6} xs={12} mb={7} flexDirection='column'>
                        <Grid container item justifyContent='flex-start' mb={2}><Typography className={classes.fieldTitle} variant="h6" >{texts["title-full-name"]}</Typography></Grid>
                        <Grid container item justifyContent='flex-start'><TextField id="fullName" name="fullName" autoComplete='off' onChange={formik.handleChange} value={formik.values.fullName} error={formik.touched.fullName && Boolean(formik.errors.fullName)} helperText={formik.touched.fullName && formik.errors.fullName} color={'warning'} placeholder={texts["placeholder-full-name"]} variant="standard" className={classes.textField} /></Grid>
                    </Grid>
                    <Grid container item md={6} xs={12} mb={7} flexDirection='column'>
                        <Grid container item justifyContent='flex-start' mb={2}><Typography className={classes.fieldTitle} variant="h6">{texts["title-registration-city"]}</Typography></Grid>
                        <Grid container item justifyContent='flex-start'><TextField id="city" name="city" onChange={formik.handleChange} value={formik.values.city} error={formik.touched.city && Boolean(formik.errors.city)} helperText={formik.touched.city && formik.errors.city} color={'warning'} variant="standard" className={classes.textField} /></Grid>
                    </Grid>
                    <Grid container item md={6} xs={12} mb={7} flexDirection='column'>
                        <Grid container item justifyContent='flex-start' mb={2}><Typography className={classes.fieldTitle} variant="h6">{texts["title-registration-business-name"]}</Typography></Grid>
                        <Grid container item justifyContent='flex-start'><TextField id="businessName" name="businessName" onChange={formik.handleChange} value={formik.values.businessName} error={formik.touched.businessName && Boolean(formik.errors.businessName)} helperText={formik.touched.businessName && formik.errors.businessName} color={'warning'} variant="standard" className={classes.textField} /></Grid>
                    </Grid>
                    <Grid container item md={6} xs={12} mb={7} flexDirection='column'>
                        <Grid container item justifyContent='flex-start' mb={2}><Typography className={classes.fieldTitle} variant="h6">{texts["title-registration-address-business"]}</Typography></Grid>
                        <Grid container item justifyContent='flex-start'><TextField id="address" name="address" onChange={formik.handleChange} value={formik.values.address} error={formik.touched.address && Boolean(formik.errors.address)} helperText={formik.touched.address && formik.errors.address} color={'warning'} variant="standard" className={classes.textField} /></Grid>
                    </Grid>
                    <Grid container item md={6} xs={12} mb={7} flexDirection='column'>
                        <Grid container item justifyContent='flex-start' mb={2}><Typography className={classes.fieldTitle} variant="h6">{texts["title-registration-birthdate"]}</Typography></Grid>
                        <Grid container item justifyContent='flex-start'>
                            {/* <TextField id="birthDate" name="birthDate" onChange={formik.handleChange} value={formik.values.birthDate} error={formik.touched.birthDate && Boolean(formik.errors.birthDate)} helperText={formik.touched.birthDate && formik.errors.birthDate} color={'warning'} placeholder='DD/MM/YYYY' variant="standard" sx={{width:'60%'}} /> */}
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <Stack spacing={3}>
                                    <DesktopDatePicker
                                        inputFormat="dd/MM/yyyy"
                                        openTo="day"
                                        views={['day', 'month', 'year']}
                                        value={formik.values.birthDate}
                                        id='birthDate' name='birthDate' onChange={val => { formik.setFieldValue("birthDate", val); }} color={'warning'}
                                        renderInput={(params) =>
                                            <TextField variant="standard" placeholder='dd/mm/yyyy' color={'warning'} helperText={formik.touched.birthDate && formik.errors.birthDate} className={classes.textField}  {...params} error={formik.touched.birthDate && Boolean(formik.errors.birthDate)} />}
                                    />
                                </Stack>
                            </LocalizationProvider>
                        </Grid>
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <Grid container justifyContent='flex-start' mb={1}>
                            <Typography className={classes.fieldTitle} variant="h6">{texts["title-registration-gender"]}</Typography>
                        </Grid>
                        <Grid container item md={6} xs={12} justifyContent='flex-start'>
                            <RadioGroup name="gender" row aria-labelledby="demo-row-radio-buttons-group-label" value={formik.values.gender} onChange={formik.handleChange}>
                                <FormControlLabel sx={{ color: colors.darkBlue, fontFamily: 'GerberaLight' }} color={'warning'} value="Mashkull" control={<Radio color='warning' value={0} />} label={texts["gender-male"]} />
                                <FormControlLabel sx={{ color: colors.darkBlue, fontFamily: 'GerberaLight' }} color={'warning'} value="Femër" control={<Radio color='warning' value={1} />} label={texts["gender-female"]} />
                            </RadioGroup>
                        </Grid>
                        {formik.touched.gender && <FormHelperText error>{formik.errors.gender}</FormHelperText>}
                    </Grid>
                    <Grid container item md={6} xs={12} flexDirection={'column'} justifyContent={'flex-end'} mb={4} mt={1}>
                        <FormGroup>
                            <FormControlLabel onChange={formik.handleChange} control={<Checkbox id="idTC" name="idTC" checked={formik.values.idTC} sx={{ [`&.${checkboxClasses.checked}`]: { color: colors.orange }, color: colors.gray }} />}
                                label={<Typography textAlign="left" color={colors.gray} fontFamily={'GerberaLight'}>
                                    {texts["terms-and-conditions-confirm"]}
                                    <Link href={termsAndConditionsSliceState.termsAndConditionsUrl} target="_blank" style={{ color: colors.orange, marginRight: 5 }}><br />{texts["terms-and-conditions"]}</Link>
                                    {texts["and-separator"]}
                                    <Link href={termsAndConditionsSliceState.privacyUrl} target="_blank" style={{ color: colors.orange }}><br />{texts["privacy-politics"]}</Link>
                                    {texts["of-ep"]}
                                </Typography>
                                } />
                        </FormGroup>
                        {formik.touched.idTC && <FormHelperText error>{formik.errors.idTC}</FormHelperText>}
                    </Grid>
                </Grid>
                <Grid item md={12} xs={12} >
                    <Button disabled={registrationSliceState.isLoading ? true : false} type='submit' className={classes.button}>{texts["button-continue"]}</Button>
                </Grid>
                <Grid item md={12} xs={12} pt={'0.8%'} >
                    <Link disabled={registrationSliceState.isLoading ? true : false} className={classes.link} onClick={onBackButtonClick} component='button' variant='body2'>{texts["button-back"]}</Link>
                </Grid>
            </Grid>
        </form>
    )
}
export default BusinessAccountFifthRegistrationStep